import React, { Component } from 'react';
import Select from "react-select";

class FormFilter extends Component {
    constructor(props){
        super(props)
        this.state = {

        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
    }

    render() {
        
        return (
            <React.Fragment>
                <div className="card mb-3">
                    <form onSubmit={this.handleSubmit}>
                        <div className={`card-body ${this.props.showMessage ? "pb-0" : null}`}>
                            <div className="row">

                                <div className="col-md-3">
                                    <label>Nombre</label>
                                    <input 
                                        type="text"
                                        name="name"
                                        className="form form-control"
                                        onChange={this.props.HandleChangeFilter}
                                        value={this.props.formFilter.name}
                                    />
                                </div>

                                {(this.props.curretTab == "task_board" || this.props.curretTab == "task_board_fordata") && (
                                    <div className="col-md-3">
                                        <input
                                            type="hidden"
                                            name="procesos_ids"
                                            value={this.props.selectedOptionUsers.procesos_ids}
                                        />
                                        <label>Usuarios</label>
                                        <Select
                                            onChange={this.props.handleChangeAutocomplete}
                                            options={this.props.users}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            autoFocus={false}
                                            className={`link-form`}
                                            classNamePrefix="select"
                                            placeholder="Seleccione"
                                            name="procesos_ids"
                                        />
                                    </div>  
                                )}

                                {this.props.showMessage && (
                                    <div className="col-md-12 mt-3 text-center">
                                        <div className="alert alert-primary" role="alert">
                                            <b>No ha seleccionado una opción válida</b>
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>

                        <div className="card-footer">
                            <button
                                className="btn-shadow btn btn-info  mr-3"
                                onClick={() => this.props.HandleClickFilter()}
                            >
                                Aplicar Filtro
                            </button>

                            <a
                                className="btn btn-outline-danger"
                                onClick={() => this.props.cancelFilter()}
                            >
                                Cancelar
                            </a>

                        </div>
                    </form>
                </div>
            </React.Fragment>
        );
    }
}

export default FormFilter;